import { BrandTypographyStyle } from "../../../models/brand.model.ts";
import { httpRequest } from "../../http";
import { BrandTypographyStyleFields, brandTypographyStylesUrl } from "./cmdGetBrandTypographyStyles";

export class CommandUpdateBrandTypographyStyle {
    async run(organizationId: string, brandId: string, styleId: number, fields: BrandTypographyStyleFields): Promise<BrandTypographyStyle> {
        const url = `${brandTypographyStylesUrl(organizationId, brandId)}${styleId}/`;
        return await httpRequest<BrandTypographyStyle>(url, { method: "PUT", body: fields });
    }
}
